module.exports = __webpack_public_path__ + "img/alex-bot-icon.3db08639.png";